import Vue from "vue"
import token from "./token"

//jwt失效码
const errorCodes = ["900", "904", "901"]
let invalidCallback = null
//获取服务端刷新的token


function configInterceptors() {
    Vue.prototype.GLOBAL.ajax.pushResponseInterceptors(
        (config) => {
            const authorization = config.headers.authorization
            if (authorization) {
                token.setToken(authorization);
            }
            return config;
        }
    )
    //服务端token过期
    Vue.prototype.GLOBAL.ajax.pushResponseInterceptors(
        (config) => {
            const appStatus = config?.data?.status;
            if (errorCodes.includes(appStatus)) {
                //清除token
                token.clearToken();

                //失效回调
                callInvalidCallback()

                //登录过期，报异常，阻止回调到then
                return Promise.reject(`JWT失效,错误码:${appStatus}`)
            } else {
                return config
            }
        },

    )



    //更新Token
    Vue.prototype.GLOBAL.ajax.pushRequestInterceptors(
        (config) => {
            if (token.isEnable()) {
                if (token.hasToken()) {
                    config.headers.common["Authorization"] = token.getToken();
                } else {
                    callInvalidCallback()
                }
            }
            return config;
        }
    )

    Vue.prototype.GLOBAL.ajax.pushResponseErrorsInterceptors(
        //需要移入axios默认方法处理集
        ({ response }) => {
            const { data, status } = response
            return { data, status }
        }
    )

}

/**
 * 失效回调
 * @param {string} appStatus JWT失效状态码
 */
function callInvalidCallback() {
    if (invalidCallback) invalidCallback.call(this)
}

export default {
    config(logoutCallback) {
        invalidCallback = logoutCallback;
        configInterceptors();
    }
}
